"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _i18next = _interopRequireDefault(require("i18next"));

function setupI18next(_ref) {
  var fallbackLng = _ref.fallbackLng,
      debug = _ref.debug;

  _i18next.default.init({
    debug: debug,
    defaultNS: 'messages',
    wait: true,
    fallbackLng: fallbackLng
  });

  return _i18next.default;
}

var _default = setupI18next;
exports.default = _default;